import './css/index.css';
import React, { Component } from 'react';
import { bool, object, element, func, string, array } from 'prop-types';
import { createPortal } from 'react-dom';

export default class extends Component {

    static propTypes = {
        isOpen: bool,
        updateState: func,
        wrapper: object.isRequired,
        refocusElement: object,
        overlayMarkup: element,
        className: string,
        data: array
    };

    constructor( props ) {

        super( props );

        this.state = { isOpen: props.isOpen };

        this.pageBody = document.querySelector( 'body' );

    }

    static getDerivedStateFromProps( props ) {

        return { isOpen: props.isOpen };

    }

    componentDidMount() {

        document.querySelector( '.info-overlay .info-overlay-content .info-overlay-close' ).focus();

    }

    componentDidUpdate( prevProps, prevState ) {

        if ( this.props.isOpen !== this.state.isOpen && prevState.isOpen === this.state.isOpen ) {

            this.setState( { isOpen: this.props.isOpen } );

        }

    }

    createOverlay = () => {

        const { overlayMarkup, className, isOpen, wrapper, refocusElement, ...childProps } = this.props;

        this.pageBody.setAttribute( 'aria-hidden', true );

        const childrenWithProps = React.cloneElement( overlayMarkup, { onClose: this.updateAriaHidden, ...childProps } );


        return (
            createPortal(
                <div
                    className={ `info-overlay-content ${ className }` }
                    id='info-overlay-content'
                    aria-hidden={ this.state.isOpen ? false : true }
                    role={ this.state.isOpen ? 'dialog' : '' }
                    aria-labelledby='overlay-title'
                    aria-describedby='overlay-header'
                    tabIndex='-1'
                >
                    <button
                        tabIndex='0'
                        onClick={ this.updateAriaHidden }
                        className='info-overlay-close'
                        type='button' aria-label='Close'
                        aria-labelledby='overlay-title'
                        aria-describedby='overlay-body'
                    >
                        &times;
                    </button>
                    <div className='info-overlay-markup'>{ childrenWithProps }</div>
                </div>,
                this.props.wrapper
            )
        );

    };

    removeOverlay = () => {

        const el = this.props.wrapper;

        if ( el ) {

            el.parentNode.removeChild( el );

        }

    };

    updateAriaHidden = () => {

        this.pageBody.setAttribute( 'aria-hidden', false );

        this.removeOverlay();

        this.props.refocusElement ? this.props.refocusElement.focus() : null;


        return null;

    };

    render() {

        return this.state.isOpen ? this.createOverlay() : this.updateAriaHidden();

    }

}
